// export const RESOURCES = "//localhost:3001/resources";
export const RESOURCES = "https://resources.xbot.com.vn";
export const EXPORT_URL = "https://edubots.xbot.com.vn/rebot/htmlReport";
export const NOTIFICATIONS =
  "https://aios.xbot.com.vn/api/notifications";

// export const BACKEND_URL = "//localhost:3001";
export const BACKEND_URL = "//pa.back3nd.xyz:3000";
